import { createContext, useContext, useEffect, useState } from "react";
import { api, resolveImage } from "@/lib/api";

const SettingsCtx = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      applyColors(data?.colors);
      applyMeta(data);
    } catch (e) {
      console.error("settings load failed", e);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsCtx.Provider value={{ settings, refresh, setSettings }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);

export function applyColors(colors) {
  if (!colors) return;
  const root = document.documentElement;
  if (colors.indigo) root.style.setProperty("--ot-indigo", colors.indigo);
  if (colors.peach) root.style.setProperty("--ot-peach", colors.peach);
  if (colors.mint) root.style.setProperty("--ot-mint", colors.mint);
  if (colors.coral) root.style.setProperty("--ot-coral", colors.coral);
}

/** Apply favicon from settings. Title + meta description are managed per-page by <Seo> (react-helmet-async). */
export function applyMeta(settings) {
  if (!settings) return;
  if (settings.favicon_url) {
    const href = resolveImage(settings.favicon_url);
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = href;
  }
}
